import { combineReducers } from "redux";
import evaluationsReducer from "./Evaluations";
import catalogsReducer from "./catalogs/Index";

export default combineReducers({
  evaluations: evaluationsReducer,
  catalogs: catalogsReducer
});
